import { ConnectionType } from '@sembo-private/maps';

export const DEFAULT_TRANSPORT_TYPE = ConnectionType.NONE;
export const DEFAULT_TRANSPORT_TYPE_BETWEEN_DESTINATION = ConnectionType.CAR;

export const isFlightTransport = (fromType: ConnectionType): boolean =>
  fromType === ConnectionType.FLIGHT;

export const isFerryTransport = (fromType: ConnectionType): boolean =>
  fromType === ConnectionType.FERRY;

export const isBookableTransport = (fromType: ConnectionType): boolean =>
  isFlightTransport(fromType) || isFerryTransport(fromType);
